import { useCallback } from "react";

export function useResetForgotPassword(setForgotPassword: React.Dispatch<boolean>) {
    const resetForgotPassword = useCallback(() => {
        console.log("resetting mfa");
        setForgotPassword(false);
    }, [setForgotPassword]);

    return { resetForgotPassword }
}